import Vue from 'vue';
import Router from 'vue-router';
import * as _localStorage from '@/utils/storage';

Vue.use(Router);

const routes = [
  {
    name: 'search',
    component: () => import('./view/search/index'),
    meta: {
      title: '成绩查询',
    },
  },
  {
    name: 'list',
    component: () => import('./view/search/list'),
    meta: {
      title: '考试结果',
    },
  },
  {
    name: 'result',
    component: () => import('./view/search/result'),
    meta: {
      title: '查看结果',
    },
  },
  {
    name: 'subject-result',
    component: () => import('./view/search/subject-result.vue'),
    meta: {
      title: '查看结果',
    },
  },
  {
    name: '404',
    component: () => import('./view/404'),
    meta: {
      title: '404',
    },
  },
];

// add route path
routes.forEach((route) => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });
const routerPaths = new Set(routes.map(v => v.path));
router.beforeEach((to, from, next) => {
  if (!routerPaths.has(to.path)) {
    _localStorage.setStorageSync('toPath', to.fullPath);
    next('/404');
  } else {
    const title = to.meta && to.meta.title;
    if (title) {
      document.title = title;
    }
    next();
  }
});

export { router };

